import nexcess from "@/store/company-config/nexcess";
import thermo from "@/store/company-config/thermo";

const company = {
  namespaced: true,
  state: {
    current: process.env.VUE_APP_COMPANY || "nexcess",
    list: {
      nexcess,
      thermo,
    },
    widget: process.env.VUE_APP_COMPANY_WIDGET,
  },
  mutations: {
    SET_COMPANY(state, payload) {
      state.current = payload;
    },
    TOGGLE_COMPANY_WIDGET(state) {
      state.widget = !state.widget;
    },
  },
  actions: {
    setCompany({ commit }, payload) {
      commit("SET_COMPANY", payload);
    },
    toggleWidget({ commit }) {
      commit("TOGGLE_COMPANY_WIDGET");
    },
  },
  getters: {
    getCompany: (state) => {
      return {
        name: state.current,
        ...state.list[state.current],
      };
    },
    getWidget: (state) => {
      return state.widget;
    },
  },
};

export default company;
